<template>
  <nav class="singleNavbar">
    <div class="singleNavbar-background"></div>
    <div class="singleNavbar-container">
      <div class="singleNavbar-button" @click="$store.commit('toggleContactPopupOpen', true);">
        Contact Agent
      </div>
      <div class="singleNavbar-anchors">
        <a class="singleNavbar-anchor" href="#details">Description</a>
        <a class="singleNavbar-anchor" href="#features">Features & Amenities</a>
        <a class="singleNavbar-anchor" href="#location">Location</a>
      </div>
      <div class="singleNavbar-tabletButtons">
        <router-link
          id="tomap"
          class="headerMenu-iconLink bounceY headerMenu-link"
          :to="{ name: 'MapPage', query: { id: $route.name == 'SinglePage' ? $route.params.id : null, location: 1 } }"
        >
          <SvgComponent name="location" />
        </router-link>

        <div class="burger" tabindex="0">
          <SvgComponent name="burger" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
      
    },
  };
</script>

<style lang="scss">
  .singleNavbar {
    display: contents;

    @include phone {
      display: none;
    }

    &-background,
    &-container {
      position: sticky;
      top: 0;
      z-index: 9;
      height: 120px;
      transition: top 0.3s;

      .header-visible-sticky & {
        top: 120px;
      }

      @include tablet {
        height: 100px;

        .header-visible-sticky & {
          top: 62px;
        }
      }

      @include phone {
        display: none;
      }
    }

    &-background {
      background: #FFFAF3;
      box-shadow: 0px 1px 2px 0px rgba(91, 91, 91, 0.2);
    }

    &-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 0;

      @include tablet {
        padding: 20px 0;
      }
    }

    &-button {
      height: 100%;
      background: $red;
      color: white;
      width: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: lowercase;
      font-weight: 600;
      cursor: pointer;
      font-size: 17px;
      position: relative;
      z-index: 1;
      text-transform: uppercase;
      @include middle {
        // min-width: 110px;
        font-size: 16px;
      }
      @include phone {
        width: 100%;
        height: 64px;
        font-size: 24px;
      }
      &:focus {
        filter: brightness(0.5);
      }
    }

    &-tabletButtons {
      display: none;
      @include tablet {
        display: flex;
        gap: 55px;
      }
      @include phone {
        display: none;
      }
      
    }

     &-anchors {
      display: flex;
      gap: 60px;
      a {
        font-size: 18px;
        font-weight: 600;
        color: #1F1E1E;
        cursor: pointer;
        &:hover {
          color: $red;
        }
      }

      @include tablet {
        display: none;
      }
    }
   }
</style>